import { IUser } from '@shared/shared/interfaces/user.interfaces';
import * as userActions from '../actions';

export enum LogInFormErrors {
  ACCESS_DENIED = 'access-denied',
  EXCEEDED_ACCESS_ATTEMPTS = 'exceeded-access-attempts',
  WRONG_EMAIL_OR_PASSWORD = 'wrong-email-or-password',
  WRONG_SITE_ID = 'wrong-site-id',
}

export interface UserState extends IUser {
  loading: boolean;
  loaded: boolean;
  loginForm: {
    message_label: string;
    message_class: string;
    failureLimit: number | null;
    waitTime: string;
  };
}

export const initialState: UserState = {
  isAuthenticated: false,
  id: 0,
  member_id: 0,
  member_profile_id: 0,
  preferences: [],
  loading: false,
  loaded: false,
  loginForm: {
    message_class: '',
    message_label: '',
    failureLimit: null,
    waitTime: '',
  },
};

export function getErrorMessage(data: any): any {
  let message_label, failureLimit, waitTime;

  if (!data) {
    message_label = LogInFormErrors.ACCESS_DENIED;
  } else {
    if (data.error && data.error.cooloff_time && data.error.failure_limit) {
      message_label = LogInFormErrors.EXCEEDED_ACCESS_ATTEMPTS;
      failureLimit = data.error.failure_limit;
      waitTime = 30;
    } else {
      switch (data.status) {
        case 403: {
          message_label = LogInFormErrors.WRONG_EMAIL_OR_PASSWORD;
          break;
        }
        case 500: {
          message_label = LogInFormErrors.WRONG_SITE_ID;
          break;
        }
        default:
          message_label = LogInFormErrors.ACCESS_DENIED;
      }
    }

    return {
      message_class: 'alert-danger',
      message_label,
      failureLimit,
      waitTime,
    };
  }
}

export function reducer(state: UserState = initialState, action: userActions.UserAction): UserState {
  switch (action.type) {
    case userActions.USER_LOGIN: {
      return {
        ...state,
        loading: true,
      };
    }

    case userActions.USER_LOGIN_SUCCESS: {
      return {
        ...state,
        id: action.payload.user_id,
        isAuthenticated: true,
        member_id: action.payload.member_id,
        member_profile_id: action.payload.member_profile_id,
        loading: false,
        loaded: true,
        loginForm: {
          message_class: '',
          message_label: '',
          failureLimit: null,
          waitTime: '',
        },
      };
    }

    case userActions.USER_LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
      };
    case userActions.USER_LOGOUT_SUCCESS:
    case userActions.USER_LOGOUT_FAIL: {
      return {
        ...initialState,
      };
    }

    case userActions.USER_LOGIN_FAIL: {
      return {
        ...initialState,
        loading: false,
        loaded: false,
        loginForm: getErrorMessage(action.payload),
      };
    }

    case userActions.USER_LOGIN_OAUTH: {
      return {
        ...state,
        loading: true,
      };
    }

    case userActions.USER_LOGIN_OAUTH_SUCCESS: {
      return {
        ...state,
        id: action.payload.user_id,
        isAuthenticated: true,
        member_profile_id: action.payload.member_profile_id,
        loading: false,
        loaded: true,
      };
    }

    case userActions.USER_LOGIN_OAUTH_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case userActions.USER_VIEW_LOCAL: {
      return {
        ...state,
        loading: true,
      };
    }

    case userActions.USER_VIEW_LOCAL_SUCCESS: {
      const data = JSON.parse(action.payload);
      return {
        ...state,
        ...data,
        loading: false,
        loaded: true,
      };
    }

    case userActions.USER_REFRESH_ACCESS_TOKEN_SUCCESS: {
      return {
        ...state,
        id: action.payload.user_id,
        isAuthenticated: true,
        member_profile_id: action.payload.member_profile_id,
      };
    }

    case userActions.USER_REFRESH_ACCESS_TOKEN_FAIL: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
}

export const getAuthenticated = (state: UserState) => state.isAuthenticated;
export const getUserLoginForm = (state: UserState) => state.loginForm;
